import { h } from 'preact';
import { PIANO_VALUE_POSITION_VIDEO_QUALITY } from '../../../../../monitoring/piano/types';
import { USER_CLICK, USER_QUALITY_CHANGED } from '../../../../../types';
import { usePlayerContext, useStyles } from '../../../../common/hooks';
import Position from '../../../../common/utils/Position';
import { connect } from '../../../hoc';
import Selectable from '../../common/menu/Selectable';
import { CONTENT_FLEX_WITH_GAP } from '../../common/menu/styles';

function Quality({
  selectedQualityLevel,
  currentQualityLabel: currentLabel,
  mappedQualities,
  isAutomaticLevelSelected,
  automaticLevelLabel
}) {
  const player = usePlayerContext();
  const setStyles = useStyles();

  const onSelect = ({ level, previousLabel, newLabel, bitrate, resolution }) => {
    player.setVideoQuality({ bitrate, resolution });
    player.userEvents$.next({
      action: USER_QUALITY_CHANGED, source: USER_CLICK,
      value: {
        previousLabel,
        newLabel,
        level,
        position: PIANO_VALUE_POSITION_VIDEO_QUALITY,
        bitrate,
        resolution
      }
    });
  };

  return (
    <div
      style={setStyles({
        default: { fontSize: 16, ...CONTENT_FLEX_WITH_GAP },
        large: { fontSize: 18 }
      })}
    >
      <Position>
        {mappedQualities.map(({ label, level, isEco, bitrate, resolution }, i) => (
          <Selectable
            label={isAutomaticLevelSelected && level === -1 ? automaticLevelLabel : label}
            radioButton
            icon={isEco ? (level === selectedQualityLevel && 'eco-activated') || 'eco' : ''}
            active={level === selectedQualityLevel}
            onSelect={() => onSelect({
              level,
              newLabel: label,
              previousLabel: currentLabel,
              bitrate,
              resolution
            })}
            index={i + 2}
            totalCount={mappedQualities.length + 1}
          />
        ))}
      </Position>
    </div>
  );
}

const selector = ({
  playback: {
    selectedQualityLevel,
    currentQualityLabel,
    mappedQualities,
    isAutomaticLevelSelected,
    automaticLevelLabel
  }
}) => ({
  selectedQualityLevel,
  currentQualityLabel,
  mappedQualities,
  isAutomaticLevelSelected,
  automaticLevelLabel
});

export default connect(selector)(Quality);
